import { Component } from 'react';
import { connect } from 'react-redux';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Nav,
  NavItem,
  Button
} from 'reactstrap';
import * as actions from '../../actions';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import { getTranslationKey } from '../../modules/utils';

interface Props {
  logoutUser: (logoutAll?: boolean) => void;
  onlyLogout?: boolean;
  whiteLabel: any;
  userType?: string;
  trackEventAction?: (payload: any) => void;
  location?: any;
}

interface State {
  dropdownOpen: boolean;
}

class DefaultAppHeaderDropdown extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { dropdownOpen: false };

    this.toggle = this.toggle.bind(this);
  }

  toggle(): void {
    this.setState((prevState) => ({ dropdownOpen: !prevState.dropdownOpen }));
  }

  render() {
    const { logoutUser, onlyLogout, whiteLabel, userType } = this.props;

    return onlyLogout ? (
      <Nav className="ml-auto" navbar>
        <Dropdown
          isOpen={this.state.dropdownOpen}
          toggle={this.toggle}
          className="custom-dropdown-position"
        >
          <DropdownToggle nav>
            <img src="assets/img/misc/user.png" className="img-avatar" alt="" />
          </DropdownToggle>
          <DropdownMenu end style={{ right: 'auto' }}>
            <DropdownItem onClick={() => logoutUser(true)}>
              <i className="fa fa-lock" />
              {getTranslationKey('logout')}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Nav>
    ) : (
      <Nav className="ml-auto" navbar>
        {/* {userType === 'SB' && (
          <NavItem className="d-md-down-none pr-3">
            <Button
              color="primary"
              target="_blank"
              href={`${window.API_URL}/api/users/redirect/canny`}
              className="btn-outline"
            >
              <i className="fa fa-icon fa-comments" /> {getTranslationKey('feedback')}
            </Button>
          </NavItem>
        )} */}

        {userType === 'SB' && get(window.Intercom, 'booted') && (
          <Button
            className="mr-3 btn-outline d-sm-down-none"
            color="primary"
            onClick={() => {
              window.Intercom && window.Intercom('show');
            }}
          >
            <i className="icon-info" /> {getTranslationKey('helpButton')}
          </Button>
        )}

        {!whiteLabel.hideElements.includes('subscription') && (
          <NavItem className="pr-3">
            <Button
              data-cy="UpgradeAccount"
              className="primary-highlight-shadow"
              color="primary"
              href="/#/subscription/pricing"
              onClick={() =>
                this.props.trackEventAction({
                  name: 'clicked-action',
                  payload: {
                    button_id: 'upgrade-account',
                    location: this.props.location.pathname,
                    placement: 'header'
                  }
                })
              }
            >
              <i className="fa fa-icon fa-rocket" />{' '}
              <span className="d-sm-down-none">
                {getTranslationKey('upgradeAccount')}
                {' + '}
              </span>
              {getTranslationKey('pricingPage')}
            </Button>
          </NavItem>
        )}
      </Nav>
    );
  }
}

interface RootStateAuth {
  digistore?: any;
  whiteLabel: { hideElements: string[]; [k: string]: any };
  registrationProcess?: any;
  type?: string;
  subscription?: { plan?: any } | null;
  languageSoftware?: any;
}

interface RootState {
  auth: RootStateAuth;
}

function mapStateToProps(state: RootState) {
  const auth = state?.auth ?? ({} as RootStateAuth);
  const { digistore, whiteLabel, registrationProcess, type, languageSoftware } =
    auth as RootStateAuth;

  return {
    digistore,
    whiteLabel,
    registrationProcess,
    userType: type,
    userSubscriptionPlan: auth?.subscription?.plan,
    languageSoftware
  };
}

export default withRouter(
  connect<any, typeof actions, any, any>(mapStateToProps, actions)(DefaultAppHeaderDropdown)
);
